export default __webpack_public_path__ + "static/media/bg.4776946b.jpg";